import { Form, Select } from "antd";
import { getIsVisibleLookups } from "utilities/generalUtility";
import { LabeledField } from "../labeledField/labeledField";

const { Option } = Select;

export const JobGroupField = ({
  lookupTables = {},
  clientId,
  editData,
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const jobGroupLookups = lookupTables.jobGroup || [];

  const renderField = () => (
    <Select
      showSearch
      allowClear
      placeholder="Select Job Groups"
      optionFilterProp="children"
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      disabled={disabled}
      style={style}
    >
      {getIsVisibleLookups(
        jobGroupLookups.filter(
          (lookup) => parseInt(lookup.clientId) === parseInt(clientId),
        ),
        editData?.jobGroup?.id,
      ).map((item) => (
        <Option key={item.id} value={item.id} disabled={item.isVisible !== 1}>
          {item.name}
        </Option>
      ))}
    </Select>
  );

  if (isFormItem) {
    return (
      <Form.Item label="Job Group" name="jobGroupsId">
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Job Group" extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
